import defaultReducer from "./defaultReducer";
import { defaultGrid } from "../../helpers/datagrid";

const initialState = { 
    open: false,
    ...defaultGrid
}

export default defaultReducer('PROMO_ANALYSIS_DETAILS_MODAL', initialState);